// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:where(.vuetify-styles) .v-ripple__container {
  color: inherit;
  border-radius: inherit;
  position: absolute;
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
  overflow: hidden;
  z-index: 0;
  pointer-events: none;
  contain: strict;
}
:where(.vuetify-styles) .v-ripple__animation {
  color: inherit;
  position: absolute;
  top: 0;
  left: 0;
  border-radius: 50%;
  background: currentColor;
  opacity: 0;
  pointer-events: none;
  overflow: hidden;
  will-change: transform, opacity;
}
:where(.vuetify-styles) .v-ripple__animation--enter {
  transition: none;
  opacity: 0;
}
:where(.vuetify-styles) .v-ripple__animation--in {
  transition: transform 0.25s cubic-bezier(0, 0, 0.2, 1), opacity 0.1s cubic-bezier(0, 0, 0.2, 1);
  opacity: calc(0.25 * var(--v-theme-overlay-multiplier));
}
@media (prefers-reduced-motion: reduce) {
  :where(.vuetify-styles) .v-ripple__animation--in {
    transition-property: opacity;
    transition-duration: 0.1s;
  }
}
:where(.vuetify-styles) .v-ripple__animation--out {
  transition: opacity 0.3s cubic-bezier(0, 0, 0.2, 1);
  opacity: 0;
}`, "",{"version":3,"sources":["webpack://./node_modules/vuetify/lib/directives/ripple/VRipple.css"],"names":[],"mappings":"AAAA;EACE,cAAc;EACd,sBAAsB;EACtB,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,OAAO;EACP,MAAM;EACN,gBAAgB;EAChB,UAAU;EACV,oBAAoB;EACpB,eAAe;AACjB;AACA;EACE,cAAc;EACd,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,kBAAkB;EAClB,wBAAwB;EACxB,UAAU;EACV,oBAAoB;EACpB,gBAAgB;EAChB,+BAA+B;AACjC;AACA;EACE,gBAAgB;EAChB,UAAU;AACZ;AACA;EACE,+FAA+F;EAC/F,uDAAuD;AACzD;AACA;EACE;IACE,4BAA4B;IAC5B,yBAAyB;EAC3B;AACF;AACA;EACE,mDAAmD;EACnD,UAAU;AACZ","sourcesContent":[".v-ripple__container {\n  color: inherit;\n  border-radius: inherit;\n  position: absolute;\n  width: 100%;\n  height: 100%;\n  left: 0;\n  top: 0;\n  overflow: hidden;\n  z-index: 0;\n  pointer-events: none;\n  contain: strict;\n}\n.v-ripple__animation {\n  color: inherit;\n  position: absolute;\n  top: 0;\n  left: 0;\n  border-radius: 50%;\n  background: currentColor;\n  opacity: 0;\n  pointer-events: none;\n  overflow: hidden;\n  will-change: transform, opacity;\n}\n.v-ripple__animation--enter {\n  transition: none;\n  opacity: 0;\n}\n.v-ripple__animation--in {\n  transition: transform 0.25s cubic-bezier(0, 0, 0.2, 1), opacity 0.1s cubic-bezier(0, 0, 0.2, 1);\n  opacity: calc(0.25 * var(--v-theme-overlay-multiplier));\n}\n@media (prefers-reduced-motion: reduce) {\n  .v-ripple__animation--in {\n    transition-property: opacity;\n    transition-duration: 0.1s;\n  }\n}\n.v-ripple__animation--out {\n  transition: opacity 0.3s cubic-bezier(0, 0, 0.2, 1);\n  opacity: 0;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
